const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const AT = require("../vault/ActionTypes");
const withVaultDispatch = require("../hoc/withVaultDispatch");

const Sounds = require("../util/Sounds");
const styles = require("./styles/TutorialModalButton.css");

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withVaultDispatch(Component);
	return Component;
};

module.exports = augment(
	createReactClass({
		displayName: "BugReportButton",

		propTypes: {
			className: PT.string,
			withText: PT.bool, //has "Report a Bug" text

			// Injected by HOC
			dispatch: PT.func.isRequired,
		},

		onClick: function(evt) {
			Sounds.playSound("button-click");
			this.props.dispatch({
				type: AT.REPORT_BUG,
			});
		},

		render: function() {
			let mainClass = this.props.className;

			let text;
			if (this.props.withText) {
				text = <span className={styles.text}>Report a Bug</span>;
				mainClass += " " + styles.mainText;
			}
			return (
				<div className={mainClass} onClick={this.onClick}>
					<svg
						version="1.1"
						x="0px"
						y="0px"
						viewBox="0 0 50 50"
						width="50"
						height="50"
						preserveAspectRatio="none"
						className={styles.image}
					>
						<g id="Header_Buttons">
							<polygon
								className={styles.imageColor}
								points="16.4,19.6 10.9,25.3 11.2,34 16.2,39 23.7,41.1 24.7,17.5"
							/>
							<path
								className={styles.imageColor}
								d="M34.5,19.6l5.4,9.8l-5.4,9.9c0,0-7.2,2.4-7.4,2.4L26,17.4L34.5,19.6z"
							/>
							<polygon
								className={styles.imageColor}
								points="32.7,17 28.2,11 21.8,11 18,17.1 25.7,15.2"
							/>
							<polygon
								className={styles.imageColor}
								points="26.1,10 27.1,10 31.9,4.7 29.5,4.7"
							/>
							<polygon
								className={styles.imageColor}
								points="23.7,10 22.8,10 19.2,4.7 21.8,4.7"
							/>
							<path
								className={styles.imageColor}
								d="M12.5,20.8l-1.3,1.3c0,0-6.4-3.8-6.4-3.9s3-1.7,3-1.7L12.5,20.8z"
							/>
							<polygon
								className={styles.imageColor}
								points="9.2,29.3 9.3,30.8 4.2,32.2 3.3,28.9"
							/>
							<polygon
								className={styles.imageColor}
								points="14.5,39.9 15.2,40.6 15.8,40.7 13.7,45.3 10.6,43.5"
							/>
							<polygon
								className={styles.imageColor}
								points="37.5,20.9 38.4,22.4 44.8,20.3 43.3,17.5"
							/>
							<polygon
								className={styles.imageColor}
								points="41.6,28.6 41.9,29.4 41.6,30.1 46.2,31.5 46.7,28.6"
							/>
							<polygon
								className={styles.imageColor}
								points="37.6,37.4 36.8,39 39.4,43.5 41.9,42.2"
							/>
						</g>
					</svg>
					{text}
				</div>
			);
		},
	})
);
